<app-app-header></app-app-header>
<router-outlet />
<app-app-footer></app-app-footer>
<app-consent-banner></app-consent-banner>